import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { Button, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import Swal from "sweetalert2";
import PropTypes from "prop-types";
// import {
//     fetchAvailableTimeSlots,
//     bookAppointment,
//     cancelLeadAppointment,
//     collectAppointmentPayment,
// } from "../../../../services/AppointmentService";
import { getDoctorsAction } from "../../../../store/actions/DoctorsAction";
import {
    rescheduleAppointmentAction,
    rescheduleQueueAppointmentAction,
} from "../../../../store/actions/ReceptionistAction";
import {
    handleSuccess,
    showErrorAlert,
} from "../../../../services/ErrorHandlingService";
import Select from "react-select";
import "./PanchkarmaCommonAppointmentCalendar.css";
import { getSettingUsersAction } from "../../../../store/actions/SettingAction";
import { getLeadDetailsAction } from "../../../../store/actions/LeadAction";
import { getPatientDetailsAction } from "../../../../store/actions/PatientsAction";
import SendPaymentLinkButton from "./SendPaymentLinkButton";

//const isServiceCaller = localStorage.getItem("role_name") === "Service Caller";
const therapistOptions = [
    { value: "Dr. Sharma", label: "Dr. Sharma" },
    { value: "Dr. Mehta", label: "Dr. Mehta" },
    { value: "Dr. Kulkarni", label: "Dr. Kulkarni" },
    { value: "Dr. Iyer", label: "Dr. Iyer" },
];

  

const PanchkarmaCommonAppointmentCalendar = ({
    module = "telecaller",
    leadId = null,
    patientId = null,
    doctorId = null,
    appointmentType = "",
    currentPatientId = null,
    currentLeadId = null,
    allowBooking = true,
    onBookingSuccess = null,
    onCancelSuccess = null,
    onRescheduleSuccess = null,
    onRescheduleError = null,
    onRescheduleStart = null,
    onRescheduleEnd = null,
    initialStartDate = null,
    initialEndDate = null,
    initialAppointmentId = null,
    currentAppointmentData = null,
    isNewBooking = false,
}) => {
    const dispatch = useDispatch();
    const doctors = useSelector((state) => state.doctors.doctors || []);
    // const [calendarEvents, setCalendarEvents] = useState([]);
    const [loading, setLoading] = useState(false);
    // const [calendarLoaded, setCalendarLoaded] = useState(false);
    const [calendarEvents, setCalendarEvents] = useState([
        {
          id: "1",
          title: "Confirmed",
          start: new Date().setHours(10, 0, 0),
          end: new Date().setHours(11, 0, 0),
          backgroundColor: "#28a745",
          borderColor: "#28a745",
          textColor: "#fff",
          extendedProps: { type: "current_booking" }
        },
        {
          id: "2",
          title: "Pending",
          start: new Date().setHours(12, 0, 0),
          end: new Date().setHours(13, 0, 0),
          backgroundColor: "#ffc107",
          borderColor: "#ffc107",
          textColor: "#000",
          extendedProps: { type: "current_booking" }
        }
      ]);
    const [selectedDoctorId, setSelectedDoctorId] = useState(doctorId || null);
    console.log("selectedDoctorId:", selectedDoctorId);
    const [lastFetchedRange, setLastFetchedRange] = useState(null);
    const [showBulkModal, setShowBulkModal] = useState(false);
    const [preferredDate, setPreferredDate] = useState("");
    const [durationDays, setDurationDays] = useState("");
    const [endDate, setEndDate] = useState("");
    const [timeSlot, setTimeSlot] = useState("");

    // Modal states
    const [consultingFees, setConsultingFees] = useState("");
    const [repeatingConsultingFees, setRepeatingConsultingFees] = useState("");
    const [selectedFeeOption, setSelectedFeeOption] = useState("Consulting Fees"); // default to consulting
    const [feeValue, setFeeValue] = useState(""); // will be set in useEffect

    const [showBookingModal, setShowBookingModal] = useState(false);
    const [showRescheduleModal, setShowRescheduleModal] = useState(false);
    const [selectedSlot, setSelectedSlot] = useState(null);
    const [selectedAppointment, setSelectedAppointment] = useState(null);
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [isRescheduleMode, setIsRescheduleMode] = useState(false);
    const [paymentDetails, setPaymentDetails] = useState({
        amount: "",
        paymentType: "",
        coupon: "",
        finalAmount: "",
        appointmentId: null,
    });
    const couponInputRef = useRef();
    const [selectedTherapist, setSelectedTherapist] = useState(null);
    const [selectedRoom, setSelectedRoom] = useState(null);

    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const roleName = userDetails?.role_name;
    console.log("Logged-in Role:", roleName);

    const isServiceCaller = roleName === "Service Caller";

    // Payment link state
    const [
        selectedAppointmentForPaymentLink,
        setSelectedAppointmentForPaymentLink,
    ] = useState(null);
    const handleDurationChange = (value) => {
        setDurationDays(value);

        if (preferredDate && value) {
            const start = new Date(preferredDate);
            let newEnd = new Date(start);
            newEnd.setDate(start.getDate() + parseInt(value) - 1); // minus 1 so 1 day = same date
            setEndDate(newEnd.toISOString().split("T")[0]);
        }
    };

    // Lead email state
    const [leadEmail, setLeadEmail] = useState("");
    const [isLeadEmailLoading, setIsLeadEmailLoading] = useState(false);
    const [isEmailFetched, setIsEmailFetched] = useState(false);
    const [patientOrLeadName, setPatientOrLeadName] = useState("");

    // Get Redux state for lead and patient details
    const leadDetails = useSelector((state) => state.leadState?.leadDetails);
    const patientDetails = useSelector((state) => state.patients?.patientDetails);

    // Get email and name from Redux store based on appointment type
    const getAppointmentEmail = (appointment) => {
        setIsLeadEmailLoading(true);
        setIsEmailFetched(false);
        setPatientOrLeadName("");

        try {
            // Check if it's a lead appointment
            const appointmentLeadId = appointment.lead_id || leadId;

            if (module === "telecaller") {
                // Get lead email from Redux store
                if (leadDetails && leadDetails.lead_id === appointmentLeadId) {
                    setLeadEmail(leadDetails.email || "");
                    setPatientOrLeadName(
                        leadDetails.lead_name ||
                        leadDetails.name ||
                        leadDetails.first_name + " " + leadDetails.last_name
                    );
                    setIsLeadEmailLoading(false);
                    setIsEmailFetched(true);
                } else {
                    // If lead details not in Redux, try to fetch them
                    dispatch(getLeadDetailsAction(appointmentLeadId))
                        .then((response) => {
                            if (response?.data?.data) {
                                const leadData = response.data.data;
                                setLeadEmail(leadData.email || "");
                                setPatientOrLeadName(leadData.lead_name || leadData.name || "");
                            } else {
                                setLeadEmail("");
                                setPatientOrLeadName("");
                            }
                            setIsLeadEmailLoading(false);
                            setIsEmailFetched(true);
                        })
                        .catch((error) => {
                            console.error("Error fetching lead email:", error);
                            setLeadEmail("");
                            setPatientOrLeadName("");
                            setIsLeadEmailLoading(false);
                            setIsEmailFetched(true);
                        });
                }
            } else {
                // For regular appointments, get patient email from Redux
                if (
                    patientDetails &&
                    patientDetails.patient_id === appointment.patient_id
                ) {
                    setLeadEmail(patientDetails.patient_email || "");
                    setPatientOrLeadName(
                        patientDetails.patient_name || patientDetails.name || ""
                    );
                    setIsLeadEmailLoading(false);
                    setIsEmailFetched(true);
                } else {
                    // If patient details not in Redux, try to fetch them
                    dispatch(getPatientDetailsAction(appointment.patient_id))
                        .then((response) => {
                            if (response?.data?.data) {
                                const patientData = response.data.data;
                                setLeadEmail(patientData.patient_email || "");
                                setPatientOrLeadName(
                                    patientData.patient_name || patientData.name || ""
                                );
                            } else {
                                setLeadEmail("");
                                setPatientOrLeadName("");
                            }
                            setIsLeadEmailLoading(false);
                            setIsEmailFetched(true);
                        })
                        .catch((error) => {
                            console.error("Error fetching patient email:", error);
                            setLeadEmail("");
                            setPatientOrLeadName("");
                            setIsLeadEmailLoading(false);
                            setIsEmailFetched(true);
                        });
                }
            }
        } catch (error) {
            console.error("Error getting appointment email:", error);
            setLeadEmail("");
            setPatientOrLeadName("");
            setIsLeadEmailLoading(false);
            setIsEmailFetched(true);
        }
    };

    // Module permissions
    const getModulePermissions = () => {
        const basePermissions = {
            telecaller: {
                canBook: true,
                canCancel: true,
                canPayment: false,
                canReschedule: true,
            },
            service_caller: {
                canBook: true,
                canCancel: true,
                canPayment: true,
                canReschedule: true,
            },
            receptionist: {
                canBook: false, // Receptionist cannot book new appointments
                canCancel: true,
                canPayment: true,
                canReschedule: true,
            },
            default: {
                canBook: true,
                canCancel: false,
                canPayment: false,
                canReschedule: false,
            },
        };

        const modulePermissions =
            basePermissions[module] || basePermissions.default;

        // Override booking permission based on allowBooking prop
        return {
            ...modulePermissions,
            canBook: allowBooking && modulePermissions.canBook,
        };
    };

    const permissions = getModulePermissions();

    // Initialize doctors and fetch initial slots
    // useEffect(() => {
    //     if (doctors.length === 0) {
    //         dispatch(getDoctorsAction());
    //     }

    //     // If we have initial dates and a doctor, fetch slots
    //     if (initialStartDate && initialEndDate && selectedDoctorId) {
    //         fetchSlotsForDateRange(initialStartDate, initialEndDate);
    //     }
    // }, [
    //     dispatch,
    //     doctors.length,
    //     selectedDoctorId,
    //     initialStartDate,
    //     initialEndDate,
    // ]);

    // useEffect(() => {
    //     if (doctorId && doctors.length > 0 && !selectedDoctorId) {
    //         const foundDoctor = doctors.find(
    //             (doc) => String(doc.doctor_id) === String(doctorId)
    //         );
    //         if (foundDoctor) {
    //             setSelectedDoctorId(foundDoctor.doctor_id);
    //         }
    //     }
    // }, [doctorId, doctors, selectedDoctorId]);

    // Auto-enter reschedule mode for receptionist when appointment is provided
    useEffect(() => {
        if (
            module === "receptionist" &&
            (initialAppointmentId || currentAppointmentData)
        ) {
            // Set reschedule mode automatically since user came from appointments list
            setIsRescheduleMode(true);

            // If we have appointment data, set it as selected appointment
            if (currentAppointmentData) {
                setSelectedAppointment(currentAppointmentData);
            }
        }
    }, [module, initialAppointmentId, currentAppointmentData]);

    // Debug effect to log patient ID changes
    useEffect(() => {
        console.log("Patient ID changed:", {
            patientId: patientId,
            currentPatientId: currentPatientId,
            module: module,
        });

        // Clear calendar events when patient ID changes to force refresh
        if (patientId || currentPatientId) {
            setCalendarEvents([]);
            setLastFetchedRange(null);
            setCalendarLoaded(false);
        }
    }, [patientId, currentPatientId, module]);

    useEffect(() => {
        const fetchFees = async () => {
            try {
                const settings = await dispatch(getSettingUsersAction());

                if (Array.isArray(settings)) {
                    const consulting = settings.find(s => s.setting_name === "Consulting Fees");
                    const repeating = settings.find(s => s.setting_name === "Repeating Consulting Fees");

                    if (consulting) setConsultingFees(consulting.setting_value);
                    if (repeating) setRepeatingConsultingFees(repeating.setting_value);

                    // Default fee value logic
                    if (roleName === "Service Caller") {
                        setFeeValue(consulting?.setting_value || "");
                    } else {
                        setFeeValue(consulting?.setting_value || "");
                    }
                }
            } catch (err) {
                console.error("Failed to fetch fees:", err);
            }
        };

        fetchFees();
    }, [dispatch, roleName]);



    // Helper function to convert time format
    const convertTime = (timeStr) => {
        const [time, period] = timeStr.split(" ");
        const [hours, minutes] = time.split(":");
        let hour = parseInt(hours);

        if (period === "PM" && hour !== 12) {
            hour += 12;
        } else if (period === "AM" && hour === 12) {
            hour = 0;
        }

        return `${hour.toString().padStart(2, "0")}:${minutes}:00`;
    };

    // Helper function to check if a time slot is in the past
    const isTimeSlotInPast = (date, timeSlot) => {
        const now = new Date();
        const [startTime] = timeSlot.split(" to ").map((t) => t.trim());
        const slotDateTime = new Date(`${date}T${convertTime(startTime)}`);
        return slotDateTime < now;
    };

    // Function to check if we need to fetch slots for a date range
    const shouldFetchSlots = (start, end) => {
        if (!lastFetchedRange) return true;

        const startDate = start.toISOString().split("T")[0];
        const endDate = end.toISOString().split("T")[0];

        // Always fetch if patient ID has changed
        const currentPatientIdStr = String(patientId || currentPatientId || "");
        const lastPatientIdStr = lastFetchedRange.patientId || "";
        if (currentPatientIdStr !== lastPatientIdStr) {
            console.log("Patient ID changed, forcing fetch:", {
                current: currentPatientIdStr,
                last: lastPatientIdStr,
            });
            return true;
        }

        return (
            startDate !== lastFetchedRange.start ||
            endDate !== lastFetchedRange.end ||
            // selectedDoctorId !== lastFetchedRange.doctorId
            selectedTherapist?.value !== lastFetchedRange.therapist

        );
    };

    // Function to fetch available slots for a date range
    const fetchSlotsForDateRange = async (start, end) => {
        if (!selectedTherapist) {
            console.log("No therapist selected, skipping fetch");
            return;
          }
          

        // Check if we really need to fetch
        if (!shouldFetchSlots(start, end)) {
            console.log("Skipping fetch - already have this range");
            return;
        }

        try {
            setLoading(true);
            setCalendarLoaded(false);

            // Clear existing events to show loading immediately
            setCalendarEvents([]);
            const response = await fetchAvailableTimeSlots({
                leadId: leadId || null,
                patientId: patientId || null,
                // doctorId: selectedDoctorId,
                therapist: selectedTherapist?.value || null,
                startDate: start.toISOString().split("T")[0],
                endDate: end.toISOString().split("T")[0],
                appointmentType,
            });

            if (
                response.data?.status === "success" &&
                Array.isArray(response.data.data)
            ) {
                const processedSlots = [];
                const currentLeadIdStr = String(leadId || currentLeadId || "");
                const currentPatientIdStr = String(patientId || currentPatientId || "");

                // Debug logging for current patient ID
                console.log("Current patient ID debug:", {
                    patientId: patientId,
                    currentPatientId: currentPatientId,
                    currentPatientIdStr: currentPatientIdStr,
                    leadId: leadId,
                    currentLeadId: currentLeadId,
                    currentLeadIdStr: currentLeadIdStr,
                    module: module,
                });

                // Process each day's data
                response.data.data.forEach((daySlots) => {
                    const date = daySlots.date;

                    // Process all available slots for this day
                    if (daySlots.slots && Array.isArray(daySlots.slots)) {
                        daySlots.slots.forEach((slot) => {
                            const [startTime, endTime] = slot.time_slot
                                .split(" to ")
                                .map((t) => t.trim());

                            const startDateTime = new Date(
                                `${date}T${convertTime(startTime)}`
                            );
                            const endDateTime = new Date(`${date}T${convertTime(endTime)}`);

                            if (slot.is_available === "Yes") {
                                // Check if this slot is in the past
                                const isPastSlot = isTimeSlotInPast(date, slot.time_slot);

                                // Available slot - transparent background
                                processedSlots.push({
                                    id: `available-${date}-${slot.time_slot.replace(
                                        /\s/g,
                                        ""
                                    )}-${Math.random()}`,
                                    start: startDateTime,
                                    end: endDateTime,
                                    title: isPastSlot ? "Past" : "",
                                    backgroundColor: isPastSlot ? "#f8f9fa" : "transparent",
                                    borderColor: isPastSlot ? "#dee2e6" : "#e0e0e0",
                                    textColor: isPastSlot ? "#6c757d" : "#000000",
                                    classNames: isPastSlot
                                        ? ["past-slot", "unavailable-slot"]
                                        : ["available-slot"],
                                    display: "background",
                                    extendedProps: {
                                        type: isPastSlot ? "past" : "available",
                                        isAvailable: !isPastSlot,
                                        isPast: isPastSlot,
                                        timeSlot: slot.time_slot,
                                        time_slot: slot.time_slot,
                                        // doctor_id: selectedDoctorId,
                                        therapist: selectedTherapist?.value || null,
                                        date: date,
                                    },
                                });
                            } else if (slot.appointmentDetails) {
                                // Check if this appointment is in the past
                                const isPastAppointment = isTimeSlotInPast(
                                    date,
                                    slot.time_slot
                                );

                                // Booked slot - determine color based on ownership and payment status
                                const appointment = slot.appointmentDetails;
                                const isCurrentPatient =
                                    (currentPatientIdStr &&
                                        String(appointment.patient_id) === currentPatientIdStr) ||
                                    (currentLeadIdStr &&
                                        String(appointment.lead_id) === currentLeadIdStr);

                                // Debug logging for patient ID comparison
                                console.log("Slot comparison:", {
                                    slot: slot.time_slot,
                                    appointmentPatientId: appointment.patient_id,
                                    currentPatientIdStr: currentPatientIdStr,
                                    appointmentLeadId: appointment.lead_id,
                                    currentLeadIdStr: currentLeadIdStr,
                                    isCurrentPatient: isCurrentPatient,
                                    module: module,
                                });

                                let backgroundColor, borderColor, textColor, title;

                                if (isPastAppointment) {
                                    // Past appointment - grayed out
                                    backgroundColor = "#ffffff";
                                    borderColor = "#ffffff";
                                    textColor = "#ffffff";
                                    title = "Past";
                                } else if (isCurrentPatient) {
                                    // Current patient's appointment
                                    if (appointment.is_payment === "Yes") {
                                        // Green for confirmed appointments
                                        backgroundColor = "#28a745";
                                        borderColor = "#28a745";
                                        textColor = "#ffffff";
                                        title = "Confirmed";
                                    } else {
                                        // Yellow for current user's bookings
                                        backgroundColor = "#ffc107";
                                        borderColor = "#ffc107";
                                        textColor = "#000000";
                                        title = `Pending`;
                                    }
                                } else {
                                    // Other patient's appointment - Original red color
                                    backgroundColor = "#bb2124";
                                    borderColor = "#bb2124";
                                    textColor = "#ffffff";
                                    title = "By Other";
                                }

                                processedSlots.push({
                                    id: `booked-${appointment.appointment_id || Date.now()}`,
                                    start: startDateTime,
                                    end: endDateTime,
                                    title: title,
                                    backgroundColor: backgroundColor,
                                    borderColor: borderColor,
                                    textColor: textColor,
                                    classNames: isPastAppointment
                                        ? ["past-appointment"]
                                        : isCurrentPatient
                                            ? ["current-patient-booking"]
                                            : ["other-patient-booking"],
                                    display: "block",
                                    extendedProps: {
                                        ...appointment,
                                        type: isPastAppointment
                                            ? "past_appointment"
                                            : isCurrentPatient
                                                ? "current_booking"
                                                : "other_booking",
                                        isBooked: true,
                                        isCurrentPatient: isCurrentPatient,
                                        isPast: isPastAppointment,
                                        time_slot: slot.time_slot,
                                        //doctor_id: appointment.doctor_id || selectedDoctorId,
                                        therapist: selectedTherapist?.value || null, 
                                        date: date,
                                    },
                                });
                            }
                        });
                    }
                });

                setCalendarEvents(processedSlots);
                setLastFetchedRange({
                    start: start.toISOString().split("T")[0],
                    end: end.toISOString().split("T")[0],
                    // doctorId: selectedDoctorId,
                    therapist: selectedTherapist?.value || null,
                    patientId: currentPatientIdStr, // Store patient ID
                });

                // Mark calendar as loaded after a small delay to ensure rendering is complete
                setTimeout(() => {
                    setCalendarLoaded(true);
                }, 300);
            } else {
                showErrorAlert("Failed to fetch available time slots");
                setCalendarLoaded(true); // Mark as loaded even on error
            }
        } catch (error) {
            console.error("Error fetching time slots:", error);
            showErrorAlert("Error fetching available time slots");
            setCalendarLoaded(true); // Mark as loaded even on error
        } finally {
            setLoading(false);
        }
    };

    // Handle calendar date range change with debouncing
    const handleDatesSet = (arg) => {
        if (!selectedTherapist) {
            console.log("No therapist selected, skipping date range fetch");
            return;
        }

        // Ensure we're getting proper week boundaries for the API
        const startDate = new Date(arg.start);
        const endDate = new Date(arg.end);

        // For week view, adjust to get Monday to Sunday
        if (arg.view.type === "timeGridWeek") {
            // Set start to Monday of the week
            const dayOfWeek = startDate.getDay();
            const diff = dayOfWeek === 0 ? -6 : 1 - dayOfWeek; // If Sunday, go back 6 days, else go to Monday
            startDate.setDate(startDate.getDate() + diff);

            // Set end to Sunday of the week
            endDate.setTime(startDate.getTime());
            endDate.setDate(startDate.getDate() + 6);
        }

        console.log("Fetching slots for date range:", {
            start: startDate.toISOString().split("T")[0],
            end: endDate.toISOString().split("T")[0],
            view: arg.view.type,
        });

        // Small delay to prevent too many rapid API calls during navigation
        setTimeout(() => {
            fetchSlotsForDateRange(startDate, endDate);
        }, 100);
    };

    // Handle doctor selection
    const handleTherapistChange = (option) => {
        setSelectedTherapist(option);
        setCalendarEvents([]);      // 
        setLastFetchedRange(null);  // cache reset 
      };
      
      const handleRoomChange = (option) => {
        setSelectedRoom(option);
      };      


    // Show appointment details for paid (green) slots
    const showPaidAppointmentDetails = (appointment) => {
        Swal.fire({
            title:
                '<span style="font-size:2rem;font-weight:700;">Your Appointment Details</span>',
            html: `
        <div class="text-start" style="font-size:1.1rem;">
          <div class="mb-3">
            <p class="mb-1"><strong>Date:</strong> <span style="color:#1a237e;font-weight:600;">${(() => {
                    const [year, month, day] = appointment.date.split("-");
                    return `${day}-${month}-${year}`;
                })()
                }</span></p>

            <p class="mb-1"><strong>Time:</strong> <span style="color:#1a237e;font-weight:600;">${appointment.time_slot}</span></p>
            <p class="mb-1"><strong>Status:</strong> <span style="background:#28a745;color:#fff;padding:2px 12px;border-radius:12px;font-size:1rem;font-weight:600;vertical-align:middle;">Waiting</span></p>
            <p class="mb-0"><strong>Payment:</strong> <span style="color:#28a745;font-weight:600;">&#10003; Paid</span></p>
          </div>
        </div>
      `,
            showCancelButton: true,
            showDenyButton: false,
            showConfirmButton: false,
            cancelButtonText:
                '<span style="font-weight:600;font-size:1.1rem;">Close</span>',
            denyButtonText: "",
            confirmButtonText: "",
            confirmButtonColor: "#28a745",
            denyButtonColor: "#dc3545",
            cancelButtonColor: "#6c757d",
            width: "500px",
            customClass: {
                popup: "appointment-options-popup",
                cancelButton: "btn btn-secondary",
                denyButton: "btn btn-danger",
            },
            didOpen: () => {
                const popup = Swal.getPopup();
                popup.style.fontFamily = "inherit";
                // Add Cancel Appointment button manually
                const actions = popup.querySelector(".swal2-actions");
                const cancelBtn = document.createElement("button");
                cancelBtn.className = "btn btn-danger";
                cancelBtn.style.marginRight = "12px";
                cancelBtn.innerHTML =
                    '<span style="font-weight:600;font-size:1.1rem;">Cancel Appointment</span>';
                cancelBtn.onclick = () => {
                    Swal.close();
                    handleCancelAppointment(appointment.appointment_id);
                };
                actions.insertBefore(cancelBtn, actions.firstChild);
            },
        });
    };

    // Update event click handler for green slot
    // const handleEventClick = (info) => {
    //     const eventProps = info.event.extendedProps;

    //     // Check if doctor is selected before allowing any booking or rescheduling
    //     if (!selectedTherapist) {
    //         Swal.fire({
    //             title: "Doctor Not Selected",
    //             text: "Please select a doctor from the dropdown before booking or rescheduling appointments.",
    //             icon: "warning",
    //             confirmButtonText: "OK",
    //         });
    //         return;
    //     }

    //     // Prevent interaction with past slots and appointments
    //     if (eventProps.isPast) {
    //         Swal.fire({
    //             title: "Past Time Slot",
    //             text: "This time slot is in the past and cannot be booked or modified.",
    //             icon: "info",
    //             confirmButtonText: "OK",
    //         });
    //         return;
    //     }

    //     if (eventProps.type === "available") {
    //         // For receptionist module, allow selecting available slots for rescheduling or new booking
    //         if (module === "receptionist") {
    //             // Check if we're in reschedule mode (have a selected appointment or initial appointment)
    //             console.log("Reschedule mode check:", {
    //                 isRescheduleMode,
    //                 selectedAppointment,
    //                 initialAppointmentId,
    //                 currentAppointmentData,
    //                 module,
    //             });

    //             if (isRescheduleMode) {
    //                 // Get the appointment data - either from selected, currentAppointmentData, or from props
    //                 const appointmentToReschedule = selectedAppointment ||
    //                     currentAppointmentData || { appointment_id: initialAppointmentId };

    //                 console.log("Appointment to reschedule:", appointmentToReschedule);

    //                 // Check if this is a patient queue reschedule (has queue_id) or regular appointment reschedule (has appointment_id)
    //                 const isQueueReschedule =
    //                     appointmentToReschedule.queue_id &&
    //                     !appointmentToReschedule.appointment_id;
    //                 const isRegularReschedule = appointmentToReschedule.appointment_id;

    //                 console.log("Reschedule type check:", {
    //                     isQueueReschedule,
    //                     isRegularReschedule,
    //                     queue_id: appointmentToReschedule.queue_id,
    //                     appointment_id: appointmentToReschedule.appointment_id,
    //                 });

    //                 // Check if we have the minimum required data for rescheduling
    //                 if (
    //                     !appointmentToReschedule ||
    //                     (!isQueueReschedule && !isRegularReschedule)
    //                 ) {
    //                     console.error(
    //                         "No valid appointment ID or queue ID found for rescheduling:",
    //                         {
    //                             selectedAppointment,
    //                             currentAppointmentData,
    //                             initialAppointmentId,
    //                             appointmentToReschedule,
    //                             isQueueReschedule,
    //                             isRegularReschedule,
    //                         }
    //                     );
    //                     showErrorAlert("Invalid appointment data. Please try again.");
    //                     return;
    //                 }

    //                 // Create the slot data for rescheduling
    //                 const slotData = {
    //                     date: eventProps.date,
    //                     time_slot: eventProps.time_slot,
    //                     doctor_id: eventProps.doctor_id,
    //                 };

    //                 // Allow selecting this slot for rescheduling
    //                 setSelectedSlot(slotData);

    //                 // Show confirmation dialog
    //                 Swal.fire({
    //                     title: "Reschedule Appointment",
    //                     text: `Reschedule appointment to ${eventProps.date} at ${eventProps.time_slot}?`,
    //                     icon: "question",
    //                     showCancelButton: true,
    //                     confirmButtonText: "Yes, Reschedule",
    //                     cancelButtonText: "Cancel",
    //                 }).then((result) => {
    //                     if (result.isConfirmed) {
    //                         console.log("Reschedule confirmed with data:", {
    //                             appointmentToReschedule,
    //                             selectedAppointment,
    //                             currentAppointmentData,
    //                             initialAppointmentId,
    //                             slotData,
    //                             isQueueReschedule,
    //                             isRegularReschedule,
    //                         });

    //                         // Set the appointment for rescheduling if not already set
    //                         if (
    //                             !selectedAppointment &&
    //                             (currentAppointmentData || initialAppointmentId)
    //                         ) {
    //                             setSelectedAppointment(appointmentToReschedule);
    //                         }

    //                         // Use appropriate reschedule function based on the type
    //                         if (isQueueReschedule) {
    //                             // Use the new queue reschedule function for patient queue
    //                             handleQueueReschedule(appointmentToReschedule, slotData);
    //                         } else {
    //                             // Use the regular reschedule function for appointments
    //                             handleReschedule(appointmentToReschedule, slotData);
    //                         }
    //                     }
    //                 });
    //                 return;
    //             }

    //             // Check if this is a new booking (for queue patients without appointment_id)
    //             if (isNewBooking) {
    //                 // Allow direct booking for new appointments
    //                 setSelectedSlot({
    //                     date: eventProps.date,
    //                     time_slot: eventProps.time_slot,
    //                     doctor_id: eventProps.doctor_id,
    //                 });
    //                 setShowBookingModal(true);
    //                 return;
    //             }

    //             // If we reach here and we're in reschedule mode, we should allow rescheduling
    //             // The reschedule logic above should have handled this, but if we reach here,
    //             // it means we're in reschedule mode but the appointment data wasn't properly set
    //             if (isRescheduleMode) {
    //                 console.log("In reschedule mode but no valid appointment data found");
    //                 Swal.fire({
    //                     title: "Reschedule Mode Active",
    //                     text: "Please select an existing appointment to reschedule first.",
    //                     icon: "info",
    //                     confirmButtonText: "OK",
    //                 });
    //                 return;
    //             }

    //             // If we reach here and we're not in reschedule mode and not doing new booking,
    //             // show the message about selecting an existing appointment
    //             // Swal.fire({
    //             //   title: "Select Appointment First",
    //             //   text: "Please select an existing appointment to reschedule, then choose an available slot.",
    //             //   icon: "info",
    //             //   confirmButtonText: "OK",
    //             // });
    //             return;
    //         }

    //         // For non-receptionist modules, continue with normal booking flow
    //         // Prevent booking for past slots
    //         const slotDateTime = new Date(
    //             `${eventProps.date}T${eventProps.timeSlot
    //                 ? eventProps.timeSlot.split(" to ")[0]
    //                 : eventProps.time_slot
    //                     ? eventProps.time_slot.split(" to ")[0]
    //                     : "00:00"
    //             }`
    //         );
    //         const now = new Date();
    //         if (slotDateTime < now) {
    //             showErrorAlert("You cannot book an appointment in the past.");
    //             return;
    //         }

    //         // Available slot clicked - show booking modal only if booking is allowed
    //         if (permissions.canBook) {
    //             setSelectedSlot({
    //                 date: eventProps.date,
    //                 time_slot: eventProps.time_slot,
    //                 doctor_id: eventProps.doctor_id,
    //             });
    //             setShowBookingModal(true);
    //         } else {
    //             Swal.fire({
    //                 title: "Booking Not Allowed",
    //                 text: "Booking new appointments is not allowed in this context.",
    //                 icon: "warning",
    //                 confirmButtonText: "OK",
    //             });
    //         }
    //     } else if (eventProps.isCurrentPatient && eventProps.is_payment === "No") {
    //         // Yellow slot (unpaid appointment) - show payment/cancel options
    //         if (permissions.canPayment || permissions.canCancel) {
    //             showPaymentCancelOptions(eventProps);
    //         }
    //     } else if (eventProps.isCurrentPatient && eventProps.is_payment === "Yes") {
    //         // Green slot (paid appointment) - show details popup
    //         showPaidAppointmentDetails(eventProps);
    //     } else if (eventProps.isCurrentPatient && module === "receptionist") {
    //         // For receptionist, show reschedule option for current patient's appointments
    //         setSelectedAppointment(eventProps);
    //         setIsRescheduleMode(true);
    //         Swal.fire({
    //             title: "Appointment Options",
    //             html: `
    //       <div style="text-align: left;">
    //         <p><strong>Time:</strong> ${eventProps.time_slot}</p>
    //         <p><strong>Status:</strong> ${eventProps.is_payment === "Yes" ? "Confirmed" : "Booked"
    //                 }</p>
    //         <p><strong>Doctor:</strong> ${getDoctorName(
    //                     eventProps.doctor_id
    //                 )}</p>
    //       </div>
    //     `,
    //             showCancelButton: true,
    //             showDenyButton: true,
    //             confirmButtonText: "Reschedule",
    //             denyButtonText: "Cancel Appointment",
    //             cancelButtonText: "Close",
    //         }).then((result) => {
    //             if (result.isConfirmed) {
    //                 // Set the appointment for rescheduling and show instructions
    //                 Swal.fire({
    //                     title: "Select New Time Slot",
    //                     text: "Appointment selected for rescheduling. Now click on an available time slot to reschedule.",
    //                     icon: "info",
    //                     confirmButtonText: "OK",
    //                 });
    //             } else if (result.isDenied) {
    //                 // Handle cancel appointment
    //                 handleCancelAppointment(eventProps.appointment_id);
    //             } else {
    //                 // User cancelled, reset reschedule mode
    //                 setIsRescheduleMode(false);
    //                 setSelectedAppointment(null);
    //             }
    //         });
    //     } else if (eventProps.isCurrentPatient) {
    //         // For non-receptionist modules, show regular options
    //         showAppointmentOptions(eventProps);
    //     } else {
    //         // Other patient's appointment - show info
    //         Swal.fire({
    //             title: "Appointment Information",
    //             html: `
    //       <div style="text-align: left;">
    //         <p><strong>Time:</strong> ${eventProps.time_slot}</p>
    //         <p><strong>Status:</strong> Booked by another patient</p>
    //         <p><strong>Doctor:</strong> ${getDoctorName(
    //                 eventProps.doctor_id
    //             )}</p>
    //       </div>
    //     `,
    //             icon: "info",
    //             confirmButtonText: "OK",
    //         });
    //     }
    // };

    // 🔹 फक्त preview bulk booking slot handle करतोय
    const handleEventClick = (info) => {
        const eventProps = info.event.extendedProps;
      
        if (eventProps?.type === "preview_bulk_booking") {
          Swal.fire({
            title: "Edit Preview Slot",
            html: `
              <div style="display:flex; flex-direction:column; gap:12px; font-family:Arial, sans-serif; text-align:left;">
                
                <div style="display:flex; align-items:center; gap:10px;">
                  <label for="editDate" style="width:50px; font-weight:600;">Date:</label>
                  <input type="date" id="editDate" value="${eventProps.date}" class="swal2-input" style="flex:1; padding:6px; font-size:14px;" />
                </div>
      
                <div style="display:flex; align-items:center; gap:10px;">
                  <label for="editTime" style="width:80px; font-weight:600;">Time:</label>
                  <select id="editTime" class="swal2-input" style="flex:1; padding:6px; font-size:14px;">
                    <option value="09:00-11:00" ${eventProps.time_slot === "09:00-11:00" ? "selected" : ""}>09:00 AM - 11:00 AM</option>
                    <option value="11:00-01:00" ${eventProps.time_slot === "11:00-01:00" ? "selected" : ""}>11:00 AM - 01:00 PM</option>
                  </select>
                </div>
      
              </div>
            `,
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: "Save",
            cancelButtonText: "Cancel",
            preConfirm: () => {
              const newDate = document.getElementById("editDate").value;
              const newTime = document.getElementById("editTime").value;
              if (!newDate || !newTime) {
                Swal.showValidationMessage("Date and Time slot required");
                return false;
              }
              return { newDate, newTime };
            },
          }).then((result) => {
            if (result.isConfirmed) {
              const { newDate, newTime } = result.value;
      
              setCalendarEvents((prev) =>
                prev.map((ev) =>
                  ev.id === info.event.id
                    ? {
                        ...ev,
                        start: new Date(`${newDate}T${newTime.split("-")[0]}:00`),
                        end: new Date(`${newDate}T${newTime.split("-")[1]}:00`),
                        extendedProps: {
                          ...ev.extendedProps,
                          date: newDate,
                          time_slot: newTime,
                        },
                      }
                    : ev
                )
              );
      
              Swal.fire("Updated!", "Preview slot updated successfully", "success");
            }
          });
        }
      };
      
      
  

    // Show appointment options for current patient
    const showAppointmentOptions = (appointment) => {
        const buttons = [];

        if (permissions.canCancel) {
            buttons.push({
                text: "Cancel",
                value: "cancel",
                className: "btn btn-danger",
            });
        }

        if (buttons.length === 0) {
            Swal.fire({
                title: "Appointment Details",
                html: `
          <div style="text-align: left;">
            <p><strong>Time:</strong> ${appointment.time_slot}</p>
            <p><strong>Status:</strong> ${appointment.is_payment === "Yes" ? "Confirmed" : "Booked"
                    }</p>
            <p><strong>Doctor:</strong> ${getDoctorName(
                        appointment.doctor_id
                    )}</p>
          </div>
        `,
                icon: "info",
                confirmButtonText: "OK",
            });
            return;
        }

        Swal.fire({
            title: "Appointment Options",
            html: `
        <div style="text-align: left;">
          <p><strong>Time:</strong> ${appointment.time_slot}</p>
          <p><strong>Status:</strong> ${appointment.is_payment === "Yes" ? "Confirmed" : "Booked"
                }</p>
          <p><strong>Doctor:</strong> ${getDoctorName(
                    appointment.doctor_id
                )}</p>
        </div>
      `,
            showCancelButton: true,
            showConfirmButton: false,
            cancelButtonText: "Close",
            showDenyButton: buttons.length > 0,
            denyButtonText: "Actions",
            didOpen: () => {
                const popup = Swal.getPopup();
                const actionsContainer = document.createElement("div");
                actionsContainer.style.marginTop = "15px";
                actionsContainer.style.display = "flex";
                actionsContainer.style.gap = "10px";
                actionsContainer.style.justifyContent = "center";
                actionsContainer.style.flexWrap = "wrap";

                buttons.forEach((button) => {
                    const btn = document.createElement("button");
                    btn.className = button.className;
                    btn.textContent = button.text;
                    btn.style.margin = "5px";
                    btn.onclick = () => {
                        Swal.close();
                        handleAppointmentAction(button.value, appointment);
                    };
                    actionsContainer.appendChild(btn);
                });

                popup.querySelector(".swal2-actions").appendChild(actionsContainer);
            },
        });
    };

    // Handle appointment actions
    const handleAppointmentAction = (action, appointment) => {
        switch (action) {
            case "cancel":
                handleCancelAppointment(appointment.appointment_id);
                break;
            default:
                break;
        }
    };

    // Get doctor name
    const getDoctorName = (doctorId) => {
        const doctor = doctors.find((d) => d.doctor_id === doctorId);
        return doctor ? doctor.doctor_name : "Unknown Doctor";
    };

    // Handle booking appointment
    const handleBookAppointment = async () => {
        if (!selectedSlot) return;

        // Check if doctor is selected before allowing booking
        if (!selectedTherapist) {
            showErrorAlert(
                "Please select a doctor from the dropdown before booking appointments."
            );
            return;
        }

        try {
            setLoading(true);
            const response = await bookAppointment({
                leadId: leadId,
                patientId: patientId,
                doctorId: selectedSlot.doctor_id,
                date: selectedSlot.date,
                timeSlot: selectedSlot.time_slot,
                appointmentType: appointmentType,
            });

            if (response.data?.status === "success") {
                const successMessage = isNewBooking
                    ? "Appointment booked successfully!"
                    : "Appointment booked successfully!";

                handleSuccess(successMessage);
                setShowBookingModal(false);
                setSelectedSlot(null);

                // For new bookings, call onRescheduleSuccess to close the modal and hide calendar
                if (isNewBooking && onRescheduleSuccess) {
                    onRescheduleSuccess({
                        ...response.data.data,
                        newBooking: true,
                        bookedSlot: selectedSlot,
                    });
                    return; // Exit early to prevent calendar update
                }

                // Immediately update the calendar to show yellow slot (only for regular bookings)
                const newAppointment = {
                    id: `booked-${response.data.data.appointment_id || Date.now()}`,
                    start: new Date(
                        `${selectedSlot.date}T${convertTime(
                            selectedSlot.time_slot.split(" to ")[0]
                        )}`
                    ),
                    end: new Date(
                        `${selectedSlot.date}T${convertTime(
                            selectedSlot.time_slot.split(" to ")[1]
                        )}`
                    ),
                    title: "Pending",
                    backgroundColor: "#ffc107",
                    borderColor: "#ffc107",
                    textColor: "#000000",
                    classNames: ["current-patient-booking"],
                    display: "block",
                    extendedProps: {
                        appointment_id: response.data.data.appointment_id,
                        type: "current_booking",
                        isBooked: true,
                        isCurrentPatient: true,
                        time_slot: selectedSlot.time_slot,
                        doctor_id: selectedSlot.doctor_id,
                        date: selectedSlot.date,
                        is_payment: "No", // Initially not paid
                    },
                };

                // Remove the available slot and add the booked slot
                setCalendarEvents((prevEvents) => {
                    const filteredEvents = prevEvents.filter(
                        (event) =>
                            !(
                                event.extendedProps?.type === "available" &&
                                event.extendedProps?.date === selectedSlot.date &&
                                event.extendedProps?.time_slot === selectedSlot.time_slot
                            )
                    );
                    return [...filteredEvents, newAppointment];
                });

                if (onBookingSuccess) {
                    onBookingSuccess(response.data.data);
                }
            } else {
                showErrorAlert(response.data?.message || "Failed to book appointment");
            }
        } catch (error) {
            console.error("Error booking appointment:", error);
            showErrorAlert("Error booking appointment");
        } finally {
            setLoading(false);
        }
    };

    // Show payment/cancel options for yellow slots
    const showPaymentCancelOptions = (appointment) => {
        Swal.fire({
            title:
                '<span style="font-size:2rem;font-weight:700;">Your Appointment Details</span>',
            html: `
        <div class="text-start" style="font-size:1.1rem;">
          <div class="mb-3">
           <p class="mb-1"><strong>Date:</strong> ${(() => {
                    const [year, month, day] = appointment.date.split("-");
                    return `${day}-${month}-${year}`;
                })()
                }</p>
            <p class="mb-1"><strong>Time:</strong> ${appointment.time_slot}</p>
            <p class="mb-1"><strong>Status:</strong> <span style="background:#ffc107;color:#222;padding:2px 12px;border-radius:12px;font-size:1rem;font-weight:600;vertical-align:middle;">Waiting</span></p>
            <p class="mb-0"><strong>Payment:</strong> <span style="color:#ff9800;font-weight:600;">Payment Pending</span></p>
          </div>
        </div>
      `,
            showCancelButton: true,
            showDenyButton: true,
            showConfirmButton: true,
            showCloseButton: true,
            confirmButtonText:
                '<span style="font-weight:600;font-size:1.1rem;">Make Payment</span>',
            denyButtonText:
                '<span style="font-weight:600;font-size:1.1rem;">Send Payment Link</span>',
            cancelButtonText:
                '<span style="font-weight:600;font-size:1.1rem;">Cancel Appointment</span>',
            confirmButtonColor: "#28a745",
            denyButtonColor: "#17a2b8",
            cancelButtonColor: "#dc3545",
            width: "500px",
            customClass: {
                popup: "appointment-options-popup",
                confirmButton: "btn btn-success",
                denyButton: "btn btn-info",
                cancelButton: "btn btn-danger",
            },
            didOpen: () => {
                const popup = Swal.getPopup();
                popup.style.fontFamily = "inherit";
            },
        }).then((result) => {
            if (result.isConfirmed) {
                openCollectPaymentModal(appointment);
            } else if (result.isDenied) {
                // Handle Send Payment Link
                setSelectedAppointmentForPaymentLink(appointment);
                setShowPaymentModal(true);

                // Fetch email for the appointment
                getAppointmentEmail(appointment);
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                handleCancelAppointment(appointment.appointment_id);
            }
        });
    };

    // Show Collect Payment modal
    const openCollectPaymentModal = (appointment) => {
        setPaymentDetails({
            amount: "",
            paymentType: "",
            coupon: "",
            finalAmount: "",
            appointmentId: appointment.appointment_id,
        });
        setShowPaymentModal(true);
    };

    // Handle Collect Payment form changes
    const handlePaymentInputChange = (e) => {
        const { name, value } = e.target;
        setPaymentDetails((prev) => ({ ...prev, [name]: value }));
    };

    // Handle coupon apply (dummy logic)
    // const handleApplyCoupon = () => {
    //   // For now, just copy amount to finalAmount (real logic can be added)
    //   setPaymentDetails((prev) => ({
    //     ...prev,
    //     finalAmount: prev.amount, // You can add coupon logic here
    //   }));
    //   couponInputRef.current.blur();
    // };
    const handleApplyCoupon = () => {
        const amt = Number.parseFloat(consultingFees);
        if (!amt || amt <= 0) {
            showErrorAlert("Enter a valid amount before applying the coupon.");
            return;
        }

        if (paymentDetails.coupon.trim() === "") {
            showErrorAlert("Please enter a valid coupon code.");
            return;
        }

        // Set final amount to 0
        setPaymentDetails((prev) => ({
            ...prev,
            finalAmount: 0,
        }));

        couponInputRef?.current?.blur();
    };

    // Handle Collect Payment submit
    const handleCollectPayment = async () => {
        try {
            setLoading(true);
            await collectAppointmentPayment({
                appointment_id: paymentDetails.appointmentId,
                amount: consultingFees,
                payment_type: paymentDetails.paymentType,
                coupon_code: paymentDetails.coupon || null,
                final_amount: paymentDetails.coupon ? "0" : consultingFees,
                lead_id: module === "telecaller" ? (leadId ? leadId : "0") : "0",
                patient_id:
                    module === "service_caller" || module === "receptionist"
                        ? patientId
                            ? patientId
                            : "0"
                        : "0",
                appointment_type: appointmentType,
            });
            setCalendarEvents((prevEvents) =>
                prevEvents.map((event) => {
                    if (
                        event.extendedProps?.appointment_id === paymentDetails.appointmentId
                    ) {
                        return {
                            ...event,
                            backgroundColor: "#28a745",
                            borderColor: "#28a745",
                            textColor: "#ffffff",
                            title: "Confirmed",
                            extendedProps: {
                                ...event.extendedProps,
                                is_payment: "Yes",
                            },
                        };
                    }
                    return event;
                })
            );
            setShowPaymentModal(false);
            handleSuccess("Payment successful! Appointment confirmed.");
        } catch {
            showErrorAlert("Error processing payment");
        } finally {
            setLoading(false);
        }
    };

    // Handle cancel appointment
    const handleCancelAppointment = async (appointmentId) => {
        console.log("Cancelling appointment with id:", appointmentId);
        if (!appointmentId) {
            showErrorAlert(
                "No appointment ID provided. Please try again or refresh the page."
            );
            console.error(
                "Cancel appointment called without valid appointmentId:",
                appointmentId
            );
            return;
        }
        try {
            const result = await Swal.fire({
                title: "Are you sure?",
                text: "You want to cancel this appointment?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#d33",
                cancelButtonColor: "#3085d6",
                confirmButtonText: "Yes, cancel it!",
            });

            if (result.isConfirmed) {
                setLoading(true);
                const response = await cancelLeadAppointment(appointmentId);

                if (response.data?.status === "success") {
                    handleSuccess("Appointment cancelled successfully!");

                    // Immediately update the calendar to show available slot
                    setCalendarEvents((prevEvents) => {
                        const cancelledEvent = prevEvents.find(
                            (event) => event.extendedProps?.appointment_id === appointmentId
                        );

                        if (cancelledEvent) {
                            // Remove the cancelled appointment
                            const filteredEvents = prevEvents.filter(
                                (event) => event.extendedProps?.appointment_id !== appointmentId
                            );

                            // Add back the available slot
                            const availableSlot = {
                                id: `available-${cancelledEvent.extendedProps.date
                                    }-${cancelledEvent.extendedProps.time_slot.replace(
                                        /\s/g,
                                        ""
                                    )}-${Math.random()}`,
                                start: cancelledEvent.start,
                                end: cancelledEvent.end,
                                title: "",
                                backgroundColor: "transparent",
                                borderColor: "#e0e0e0",
                                classNames: ["available-slot"],
                                display: "background",
                                extendedProps: {
                                    type: "available",
                                    isAvailable: true,
                                    timeSlot: cancelledEvent.extendedProps.time_slot,
                                    time_slot: cancelledEvent.extendedProps.time_slot,
                                    doctor_id: cancelledEvent.extendedProps.doctor_id,
                                    date: cancelledEvent.extendedProps.date,
                                },
                            };

                            return [...filteredEvents, availableSlot];
                        }

                        return prevEvents;
                    });

                    if (onCancelSuccess) {
                        onCancelSuccess(appointmentId);
                    }
                } else {
                    showErrorAlert(
                        response.data?.message || "Failed to cancel appointment"
                    );
                }
            }
        } catch {
            showErrorAlert("Error cancelling appointment");
        } finally {
            setLoading(false);
        }
    };

    // Handle reschedule
    const handleReschedule = async (appointmentData = null, slotData = null) => {
        const appointmentToUse = appointmentData || selectedAppointment;
        const slotToUse = slotData || selectedSlot;

        // Check if doctor is selected before allowing rescheduling
        if (!selectedTherapist) {
            showErrorAlert(
                "Please select a therapist from the dropdown before rescheduling appointments."
            );
            return;
        }

        console.log("handleReschedule called with:", {
            appointmentData,
            selectedAppointment,
            appointmentToUse,
            slotData,
            selectedSlot,
            slotToUse,
        });

        if (!appointmentToUse || !slotToUse) {
            console.error("Missing data for reschedule:", {
                appointmentToUse,
                slotToUse,
            });
            return;
        }

        try {
            if (onRescheduleStart) {
                onRescheduleStart();
            }
            setLoading(true);

            const response = await dispatch(
                rescheduleAppointmentAction({
                    appointment_id: appointmentToUse.appointment_id,
                    reschedule_date: slotToUse.date,
                    reschedule_time: slotToUse.time_slot,
                    doctor_id: slotToUse.doctor_id,
                    patient_id: appointmentToUse.patient_id,
                })
            );

            if (response) {
                // Call success callback with the rescheduled appointment data
                if (onRescheduleSuccess) {
                    onRescheduleSuccess({
                        ...response,
                        rescheduledAppointment: {
                            ...appointmentToUse,
                            date: slotToUse.date,
                            time_slot: slotToUse.time_slot,
                            doctor_id: slotToUse.doctor_id,
                        },
                        originalAppointment: appointmentToUse,
                        newSlot: slotToUse,
                    });
                } else {
                    handleSuccess("Appointment rescheduled successfully!");
                }

                // Close the reschedule modal
                setShowRescheduleModal(false);
                setSelectedAppointment(null);
                setSelectedSlot(null);
                setIsRescheduleMode(false);

                // Immediately update the calendar to show the rescheduled appointment
                setCalendarEvents((prevEvents) => {
                    // Remove the original appointment
                    const filteredEvents = prevEvents.filter(
                        (event) =>
                            event.extendedProps?.appointment_id !==
                            appointmentToUse.appointment_id
                    );

                    // Create the rescheduled appointment event
                    const [startTime, endTime] = slotToUse.time_slot
                        .split(" to ")
                        .map((t) => t.trim());

                    const startDateTime = new Date(
                        `${slotToUse.date}T${convertTime(startTime)}`
                    );
                    const endDateTime = new Date(
                        `${slotToUse.date}T${convertTime(endTime)}`
                    );

                    const rescheduledEvent = {
                        id: `rescheduled-${appointmentToUse.appointment_id}-${Date.now()}`,
                        start: startDateTime,
                        end: endDateTime,
                        title: "Rescheduled",
                        backgroundColor:
                            appointmentToUse.is_payment === "Yes" ? "#28a745" : "#ffc107",
                        borderColor:
                            appointmentToUse.is_payment === "Yes" ? "#28a745" : "#ffc107",
                        textColor:
                            appointmentToUse.is_payment === "Yes" ? "#ffffff" : "#000000",
                        classNames: ["current-patient-booking"],
                        display: "block",
                        extendedProps: {
                            type: "current_booking",
                            isBooked: true,
                            isCurrentPatient: true,
                            time_slot: slotToUse.time_slot,
                            doctor_id: slotToUse.doctor_id,
                            patient_id: appointmentToUse.patient_id,
                            appointment_id: appointmentToUse.appointment_id,
                            appointment_type: appointmentType,
                            is_payment: appointmentToUse.is_payment,
                            date: slotToUse.date,
                        },
                    };

                    return [...filteredEvents, rescheduledEvent];
                });

                // Clear the last fetched range to force a fresh fetch on next calendar interaction
                setLastFetchedRange(null);
            }
        } catch (error) {
            console.error("Error rescheduling appointment:", error);

            if (onRescheduleError) {
                onRescheduleError(error);
            } else {
                showErrorAlert("Error rescheduling appointment");
            }
        } finally {
            setLoading(false);
            if (onRescheduleEnd) {
                onRescheduleEnd();
            }
        }
    };

    // Handle reschedule for patient queue (new endpoint)
    const handleQueueReschedule = async (queueData = null, slotData = null) => {
        const queueToUse = queueData || currentAppointmentData;
        const slotToUse = slotData || selectedSlot;

        // Check if doctor is selected before allowing rescheduling
        if (!selectedTherapist) {
            showErrorAlert(
                "Please select a therapist from the dropdown before rescheduling appointments."
            );
            return;
        }

        console.log("handleQueueReschedule called with:", {
            queueData,
            currentAppointmentData,
            queueToUse,
            slotData,
            selectedSlot,
            slotToUse,
        });

        if (!queueToUse || !slotToUse) {
            console.error("Missing data for queue reschedule:", {
                queueToUse,
                slotToUse,
            });
            return;
        }

        try {
            if (onRescheduleStart) {
                onRescheduleStart();
            }
            setLoading(true);

            // Call the new reschedule endpoint for patient queue
            const response = await dispatch(
                rescheduleQueueAppointmentAction({
                    queue_id: queueToUse.queue_id,
                    patient_id: queueToUse.patient_id,
                    reschedule_date: slotToUse.date,
                    reschedule_time: slotToUse.time_slot,
                })
            );

            if (response) {
                // Call success callback with the rescheduled appointment data
                if (onRescheduleSuccess) {
                    onRescheduleSuccess({
                        ...response,
                        rescheduledAppointment: {
                            ...queueToUse,
                            date: slotToUse.date,
                            time_slot: slotToUse.time_slot,
                            doctor_id: slotToUse.doctor_id,
                        },
                        originalAppointment: queueToUse,
                        newSlot: slotToUse,
                    });
                } else {
                    handleSuccess("Patient appointment rescheduled successfully!");
                }

                // Close the reschedule modal
                setShowRescheduleModal(false);
                setSelectedAppointment(null);
                setSelectedSlot(null);
                setIsRescheduleMode(false);

                // Immediately update the calendar to show the rescheduled appointment
                setCalendarEvents((prevEvents) => {
                    // Remove the original appointment if it exists
                    const filteredEvents = prevEvents.filter(
                        (event) => event.extendedProps?.queue_id !== queueToUse.queue_id
                    );

                    // Create the rescheduled appointment event
                    const [startTime, endTime] = slotToUse.time_slot
                        .split(" to ")
                        .map((t) => t.trim());

                    const startDateTime = new Date(
                        `${slotToUse.date}T${convertTime(startTime)}`
                    );
                    const endDateTime = new Date(
                        `${slotToUse.date}T${convertTime(endTime)}`
                    );

                    const rescheduledEvent = {
                        id: `rescheduled-queue-${queueToUse.queue_id}-${Date.now()}`,
                        start: startDateTime,
                        end: endDateTime,
                        title: "Rescheduled",
                        backgroundColor: "#28a745",
                        borderColor: "#28a745",
                        textColor: "#ffffff",
                        classNames: ["current-patient-booking"],
                        display: "block",
                        extendedProps: {
                            type: "current_booking",
                            isBooked: true,
                            isCurrentPatient: true,
                            time_slot: slotToUse.time_slot,
                            doctor_id: slotToUse.doctor_id,
                            patient_id: queueToUse.patient_id,
                            queue_id: queueToUse.queue_id,
                            appointment_type: appointmentType,
                            is_payment: "Yes", // Queue patients are considered paid
                            date: slotToUse.date,
                        },
                    };

                    return [...filteredEvents, rescheduledEvent];
                });

                // Clear the last fetched range to force a fresh fetch on next calendar interaction
                setLastFetchedRange(null);
            } else {
                throw new Error(
                    response.data?.message || "Failed to reschedule patient appointment"
                );
            }
        } catch (error) {
            console.error("Error rescheduling patient appointment:", error);

            if (onRescheduleError) {
                onRescheduleError(error);
            } else {
                showErrorAlert(
                    error.message || "Error rescheduling patient appointment"
                );
            }
        } finally {
            setLoading(false);
            if (onRescheduleEnd) {
                onRescheduleEnd();
            }
        }
    };

    const handleEventDrop = (info) => {
        const event = info.event;
      
        if (event.extendedProps?.type !== "preview_bulk_booking") {
          info.revert();
          return;
        }
      
        const oldStart = new Date(info.oldEvent.start);
        const newStart = new Date(event.start);
        const dayShift = Math.round(
          (newStart - oldStart) / (1000 * 60 * 60 * 24)
        );
      
        if (dayShift === 0) return;
      
        setCalendarEvents((prevEvents) =>
          prevEvents.map((e) => {
            if (
              e.extendedProps?.type === "preview_bulk_booking" &&
              e.extendedProps.dayNumber >= event.extendedProps.dayNumber
            ) {
              const shiftedStart = new Date(e.start);
              shiftedStart.setDate(shiftedStart.getDate() + dayShift);
      
              const shiftedEnd = new Date(e.end);
              shiftedEnd.setDate(shiftedEnd.getDate() + dayShift);
      
              return {
                ...e,
                start: shiftedStart,
                end: shiftedEnd,
                backgroundColor: "#17a2b8", 
                borderColor: "#17a2b8",
                extendedProps: {
                  ...e.extendedProps,
                  conflict: false, 
                },
              };
            }
            return e;
          })
        );
      };
      
      

    // Doctor options for select
    const doctorOptions = doctors.map((doctor) => ({
        value: doctor.doctor_id,
        label: doctor.doctor_name,
        specialization: doctor.specialization,
    }));

    // Format option label for doctor select
    const formatOptionLabel = ({ label, specialization }) => (
        <div>
            <div style={{ fontWeight: "bold" }}>{label}</div>
            <div style={{ fontSize: "0.8em", color: "#666" }}>{specialization}</div>
        </div>
    );

    // Render event content - Match original
    const renderEventContent = (eventInfo) => {
        const event = eventInfo.event;
        const eventDetails = event.extendedProps;
        const eventType = eventDetails.type;

        // Handle past slots and appointments
        if (eventDetails.isPast) {
            return (
                <div className="past-slot-content">
                    <div
                        style={{
                            fontSize: "11px",
                            color: "#6c757d",
                            textAlign: "center",
                            padding: "4px",
                            fontWeight: "500",
                            opacity: "0.7",
                        }}
                    >
                        Past
                    </div>
                </div>
            );
        }

        // Handle available slots (background events)
        if (eventType === "available") {
            const slotDateTime = new Date(
                `${eventDetails.date}T${eventDetails.timeSlot
                    ? eventDetails.timeSlot.split(" to ")[0]
                    : eventDetails.time_slot
                        ? eventDetails.time_slot.split(" to ")[0]
                        : "00:00"
                }`
            );
            const now = new Date();
            const isPast = slotDateTime < now;
            return (
                <div
                    className="available-slot-indicator"
                    style={
                        isPast
                            ? { opacity: 0.4, pointerEvents: "none", filter: "grayscale(1)" }
                            : {}
                    }
                ></div>
            );
        }

        // Handle other patient's bookings
        if (eventType === "other_booking") {
            return (
                <div className="other-booking-content">
                    <div
                        style={{
                            fontSize: "11px",
                            color: "white",
                            textAlign: "center",
                            padding: "4px",
                            fontWeight: "500",
                            opacity: "0.8",
                        }}
                    >
                        Booked By Other
                    </div>
                </div>
            );
        }

        // Handle current patient's bookings - show title as is
        return (
            <div className="current-booking-content">
                <div
                    style={{
                        fontSize: "12px",
                        textAlign: "center",
                        padding: "4px",
                        fontWeight: "600",
                    }}
                >
                    {event.title}
                </div>
            </div>
        );
    };
    const selectedDoctorOption = doctorOptions.find(
        (option) => String(option.value) === String(selectedTherapist)
    );
    return (
        <div className="calendar-minimal">
            <div
                className="calendar-legend mb-3"
                style={{
                    display: "flex",
                    gap: "12px",
                    alignItems: "center",
                    flexWrap: "wrap",
                }}
            >
                <span
                    className="legend-item"
                    style={{
                        background: "#ffc107",
                        color: "#222",
                        borderRadius: "8px",
                        padding: "2px 12px",
                        fontWeight: 400,
                        fontSize: "12px",
                    }}
                >
                    Pending
                </span>
                <span
                    className="legend-item"
                    style={{
                        background: "#28a745",
                        color: "#fff",
                        borderRadius: "8px",
                        padding: "2px 12px",
                        fontWeight: 400,
                        fontSize: "12px",
                    }}
                >
                    Confirmed
                </span>
                <span
                    className="legend-item"
                    style={{
                        background: "#bb2124",
                        color: "#fff",
                        borderRadius: "8px",
                        padding: "2px 12px",
                        fontWeight: 400,
                        fontSize: "12px",
                    }}
                >
                    Booked By Other
                </span>
                <span
                    className="legend-item"
                    style={{
                        background: "rgba(23,162,184,0.1)",
                        color: "#17a2b8",
                        border: "1px dashed #17a2b8",
                        borderRadius: "8px",
                        padding: "2px 12px",
                        fontWeight: 400,
                        fontSize: "12px",
                    }}
                >
                    Available
                </span>

                <Button
                    variant="outline-info"
                    size="sm"
                    className="ms-2"
                    onClick={() => setShowBulkModal(true)}
                >
                    Bulk Booking
                </Button>

            </div>
            <Modal show={showBulkModal} onHide={() => setShowBulkModal(false)} centered>
    <Modal.Header closeButton>
        <Modal.Title>Bulk Booking</Modal.Title>
    </Modal.Header>
    <Modal.Body>
        {/* Start Date */}
        <div className="mb-3">
            <label className="form-label"><strong>Preferred Start Date</strong></label>
            <input
                type="date"
                className="form-control"
                value={preferredDate}
                onChange={(e) => setPreferredDate(e.target.value)}
            />
        </div>

        {/* Duration Days */}
        <div className="mb-3">
            <label className="form-label"><strong>Duration (in Days)</strong></label>
            <input
                type="number"
                className="form-control"
                min="1"
                placeholder="Enter number of days"
                value={durationDays}
                onChange={(e) => handleDurationChange(e.target.value)}
                disabled={!preferredDate}
            />
        </div>

        {/* Time Slot Selection */}
        <div className="mb-3">
            <label className="form-label"><strong>Select Time Slot</strong></label>
            <select
                className="form-select"
                value={timeSlot}
                onChange={(e) => setTimeSlot(e.target.value)}
                disabled={!preferredDate}
            >
                <option value="">-- Select Time Slot --</option>
                <option value="09:00-11:00">09:00 AM - 11:00 AM</option>
                <option value="11:00-01:00">11:00 AM - 01:00 PM</option>
                {/* <option value="02:00-04:00">02:00 PM - 04:00 PM</option>
                <option value="04:00-06:00">04:00 PM - 06:00 PM</option> */}
            </select>
        </div>

        {/* End Date Preview */}
        {endDate && (
            <div className="alert alert-info">
                <i className="fas fa-calendar me-2"></i>
                <strong>End Date: </strong> {endDate}
            </div>
        )}
    </Modal.Body>
    <Modal.Footer>
    <Button
  variant="secondary"
  onClick={() => {
    setCalendarEvents((prevEvents) =>
      prevEvents.filter(
        (event) => event.extendedProps?.type !== "preview_bulk_booking"
      )
    );
    setShowBulkModal(false);
  }}
>
  Cancel
</Button>


        {/* 🔹 Preview Button */}
        <Button
  variant="info"
  onClick={() => {
    // Clear old preview events
    setCalendarEvents((prevEvents) =>
      prevEvents.filter(
        (event) => event.extendedProps?.type !== "preview_bulk_booking"
      )
    );

    const previewEvents = [];
    let current = new Date(preferredDate);
    const end = new Date(endDate);
    let dayCounter = 1;

    while (current <= end) {
      const [startTime, endTime] = timeSlot.split("-");
      const startDateTime = new Date(`${current.toISOString().split("T")[0]}T${startTime}:00`);
      const endDateTime = new Date(`${current.toISOString().split("T")[0]}T${endTime}:00`);

      // 🔹 Check overlap with existing events
      const hasConflict = calendarEvents.some((event) => {
        return (
          event.start < endDateTime &&
          event.end > startDateTime &&
          ["Confirmed", "Pending"].includes(event.title)
        );
      });

      previewEvents.push({
        id: `preview-${current.toISOString().split("T")[0]}-${timeSlot}`,
        start: startDateTime,
        end: endDateTime,
        title: `Day ${dayCounter} - Preview`,
        backgroundColor: hasConflict ? "#dc3545" : "#17a2b8", // 🔴 Red if conflict else Blue
        borderColor: hasConflict ? "#dc3545" : "#17a2b8",
        textColor: "#fff",
        classNames: ["preview-bulk-booking"],
        display: "block",
        extendedProps: {
          type: "preview_bulk_booking",
          date: current.toISOString().split("T")[0],
          time_slot: timeSlot,
          dayNumber: dayCounter,
          conflict: hasConflict, // optional info
        },
      });

      current.setDate(current.getDate() + 1);
      dayCounter++;
    }

    setCalendarEvents((prevEvents) => [...prevEvents, ...previewEvents]);
    setShowBulkModal(false);
  }}
  disabled={!preferredDate || !durationDays || !timeSlot}
>
  Preview
</Button>




        <Button
            variant="primary"
            onClick={() => {
                console.log("Bulk Booking from", preferredDate, "to", endDate, "Time Slot:", timeSlot);
                setShowBulkModal(false);
            }}
            disabled={!preferredDate || !durationDays || !timeSlot}
        >
            Confirm Bulk Booking
        </Button>
    </Modal.Footer>
</Modal>




            <div className="row">
                <div className="col-md-6">
                    <Select
                        value={selectedTherapist}
                        onChange={handleTherapistChange}
                        options={therapistOptions}
                        placeholder="Select a therapist..."
                        isClearable
                        classNamePrefix="react-select"
                        menuPortalTarget={document.body}
                        styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 2000 }),
                            menu: (base) => ({ ...base, zIndex: 2000 }),
                        }}
                    />
                    {!selectedTherapist && (
                        <div className="alert alert-warning mt-2" role="alert">
                            <i className="fas fa-exclamation-triangle me-2"></i>
                            <strong>Therapist Selection Required:</strong> Please select a therapist
                            from the dropdown above before continuing.
                        </div>
                    )}
                </div>

                <div className="col-md-6">
                    <Select
                        value={selectedRoom}
                        onChange={handleRoomChange}
                        options={[
                            { value: "room1", label: "Room 1" },
                            { value: "room2", label: "Room 2" },
                        ]}
                        placeholder="Select a room..."
                        isClearable
                        classNamePrefix="react-select"
                        menuPortalTarget={document.body}
                        styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 2000 }),
                            menu: (base) => ({ ...base, zIndex: 2000 }),
                        }}
                    />
                    {!selectedRoom && (
                        <div className="alert alert-warning mt-2" role="alert">
                            <i className="fas fa-exclamation-triangle me-2"></i>
                            <strong>Room Selection Required:</strong> Please select a room
                            from the dropdown above before continuing.
                        </div>
                    )}
                </div>
            </div>

             {/* {calendarEvents.length === 0 &&
                !loading &&
                calendarLoaded &&
                selectedTherapist && (
                    <div className="text-center mt-3">
                        <Button
                            variant="outline-primary"
                            onClick={() => {
                                if (selectedTherapist) {
                                    const startDate = new Date(initialStartDate || new Date());
                                    const endDate = new Date(initialEndDate || new Date());
                                    if (initialStartDate && initialEndDate) {
                                        // For week view, adjust to get Monday to Sunday
                                        if (initialStartDate.getDay() === 0) {
                                            startDate.setDate(startDate.getDate() - 6);
                                        } else {
                                            startDate.setDate(
                                                startDate.getDate() - startDate.getDay() + 1
                                            );
                                        }
                                        endDate.setDate(startDate.getDate() + 6);
                                    }
                                    fetchSlotsForDateRange(startDate, endDate);
                                } else {
                                    showErrorAlert("Please select a doctor first.");
                                }
                            }}
                            disabled={loading}
                        >
                            Retry Fetch Slots
                        </Button>
                    </div>
                )} */}

            {/* {selectedTherapist ? (
                <div className="calendar-wrapper position-relative">
                    {(loading || (!calendarLoaded && selectedTherapist)) && (
                        <div className="calendar-loading-overlay">
                            <div className="d-flex flex-column align-items-center">
                                <div className="spinner-border text-primary mb-2" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <small className="text-muted fw-medium">
                                    {loading
                                        ? "Loading appointments..."
                                        : "Rendering calendar..."}
                                </small>
                            </div>
                        </div>
                    )}

                    <FullCalendar
                        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                        initialView="timeGridWeek"
                        headerToolbar={{
                            left: "prev,next today",
                            center: "title",
                            right: "timeGridWeek",
                        }}
                        events={calendarEvents}
                        editable={false}
                        selectable={false}
                        selectMirror={false}
                        eventClick={handleEventClick}
                        datesSet={handleDatesSet}
                        eventContent={renderEventContent}
                        height="auto"
                        slotMinTime="09:00:00"
                        slotMaxTime="20:00:00"
                        allDaySlot={false}
                        eventDisplay="block"
                        nowIndicator={true}
                        scrollTime="09:00:00"
                        slotDuration="00:30:00"
                        firstDay={1}
                        expandRows={true}
                        handleWindowResize={false}
                        loading={loading}
                        validRange={{
                            start: new Date().toISOString().split("T")[0], // Today's date
                        }}
                    />
                </div>
            ) : (
                <div className="text-center mt-4">
                    <div className="alert alert-info" role="alert">
                        <i className="fas fa-calendar-alt me-2"></i>
                        <strong>Calendar View:</strong> Please select a doctor from the
                        dropdown above to view available appointment slots.
                    </div>
                </div>
            )}  */}
            <div className="calendar-wrapper position-relative">
  {(loading) && (
    <div className="calendar-loading-overlay">
      <div className="d-flex flex-column align-items-center">
        <div className="spinner-border text-primary mb-2" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <small className="text-muted fw-medium">
          {loading ? "Loading appointments..." : "Rendering calendar..."}
        </small>
      </div>
    </div>
  )}

<FullCalendar
  plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
  initialView="timeGridWeek"
  headerToolbar={{
    left: "prev,next today",
    center: "title",
    right: "timeGridWeek,timeGridDay",
  }}
  events={calendarEvents}
  editable={true}        // ✅ drag & drop on
  droppable={true}
  eventClick={handleEventClick} 
  eventDrop={handleEventDrop} 
  height="auto"
  slotMinTime="09:00:00"
  slotMaxTime="20:00:00"  
/>

</div>


            {/* Keep only essential modals */}
            <Modal
                show={showBookingModal}
                onHide={() => setShowBookingModal(false)}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Book Appointment</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedSlot && (
                        <>
                            <p>
                                <strong>Date:</strong> {selectedSlot.date}
                            </p>
                            <p>
                                <strong>Time:</strong> {selectedSlot.time_slot}
                            </p>
                            <p>
                                <strong>Doctor:</strong> {getDoctorName(selectedSlot.doctor_id)}
                            </p>
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={() => setShowBookingModal(false)}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleBookAppointment}
                        disabled={loading}
                    >
                        {loading ? "Booking..." : "Book Appointment"}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Reschedule Modal */}
            <Modal
                show={showRescheduleModal}
                onHide={() => setShowRescheduleModal(false)}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Reschedule Appointment</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedAppointment && (
                        <div className="mb-3">
                            <h6>Current Appointment:</h6>
                            <p>
                                <strong>Date:</strong> {selectedAppointment.date}
                            </p>
                            <p>
                                <strong>Time:</strong> {selectedAppointment.time_slot}
                            </p>
                            <p>
                                <strong>Doctor:</strong>{" "}
                                {getDoctorName(selectedAppointment.doctor_id)}
                            </p>
                        </div>
                    )}
                    {selectedSlot && (
                        <div>
                            <h6>New Time Slot:</h6>
                            <p>
                                <strong>Date:</strong> {selectedSlot.date}
                            </p>
                            <p>
                                <strong>Time:</strong> {selectedSlot.time_slot}
                            </p>
                            <p>
                                <strong>Doctor:</strong> {getDoctorName(selectedSlot.doctor_id)}
                            </p>
                        </div>
                    )}
                    {!selectedSlot && (
                        <p className="text-muted">
                            Please select a new time slot from the calendar.
                        </p>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={() => setShowRescheduleModal(false)}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="warning"
                        onClick={handleReschedule}
                        disabled={loading || !selectedSlot}
                    >
                        {loading ? "Rescheduling..." : "Reschedule"}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Collect Payment Modal */}
            <Modal
                show={showPaymentModal}
                onHide={() => {
                    setShowPaymentModal(false);
                    setSelectedAppointmentForPaymentLink(null);
                    setLeadEmail(""); // Clear email when modal is closed
                    setIsEmailFetched(false); // Reset email fetched state
                    setPatientOrLeadName(""); // Clear patient/lead name when modal is closed
                }}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {selectedAppointmentForPaymentLink
                            ? "Send Payment Link"
                            : "Collect Payment"}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {selectedAppointmentForPaymentLink ? (
                        <div>
                            <div className="mb-3">
                                <h6>Appointment Details:</h6>
                                <p>
                                    {patientOrLeadName && <strong>Patient: </strong>}
                                    {patientOrLeadName ||
                                        selectedAppointmentForPaymentLink.patient_name ||
                                        ""}
                                </p>
                                <p>
                                    <strong>Date:</strong>{" "}
                                    {(() => {
                                        const [year, month, day] = selectedAppointmentForPaymentLink.date.split("-");
                                        return `${day}-${month}-${year}`;
                                    })()}
                                </p>
                                <p>
                                    <strong>Time: </strong>{" "}
                                    {selectedAppointmentForPaymentLink.time_slot}
                                </p>
                                {isServiceCaller ? (
                                    <div className="mb-3">
                                        <label htmlFor="feeSelection">
                                            <strong>Amount (Select Fee Type)</strong>
                                        </label>
                                        <select
                                            id="feeSelection"
                                            className="form-control"
                                            value={selectedFeeOption}
                                            onChange={(e) => {
                                                const selected = e.target.value;
                                                setSelectedFeeOption(selected);
                                                setFeeValue(
                                                    selected === "Consulting Fees"
                                                        ? consultingFees
                                                        : selected === "Repeating Consulting Fees"
                                                            ? repeatingConsultingFees
                                                            : ""
                                                );
                                            }}
                                        >
                                            <option value="">-- Select Fee Type --</option>
                                            <option value="Consulting Fees">Consulting Fees</option>
                                            <option value="Repeating Consulting Fees">Repeating Consulting Fees</option>
                                        </select>
                                        {feeValue && (
                                            <small className="text-success">Selected Fee: ₹{feeValue}</small>
                                        )}
                                    </div>
                                ) : (
                                    <p>
                                        <strong>Amount:</strong> ₹{feeValue || 0}
                                    </p>
                                )}


                            </div>

                            {/* Email field for all appointments */}
                            <div className="mb-3">
                                <label className="form-label">
                                    <strong>Email Address *</strong>
                                </label>
                                <div className="position-relative">
                                    <input
                                        type="email"
                                        className="form-control"
                                        value={leadEmail}
                                        onChange={(e) => setLeadEmail(e.target.value)}
                                        placeholder={
                                            isLeadEmailLoading
                                                ? "Loading appointment details..."
                                                : leadEmail
                                                    ? "Email found"
                                                    : "Email not present"
                                        }
                                        disabled={isLeadEmailLoading || !leadEmail}
                                        readOnly={leadEmail && leadEmail.trim() !== ""} // Read-only if email exists
                                    />
                                    {isLeadEmailLoading && (
                                        <div className="position-absolute top-50 end-0 translate-middle-y me-2">
                                            <div
                                                className="spinner-border spinner-border-sm text-primary"
                                                role="status"
                                            >
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                {isLeadEmailLoading && (
                                    <small className="text-muted">
                                        <i className="fas fa-spinner fa-spin me-1"></i>
                                        Loading appointment details...
                                    </small>
                                )}
                                {!leadEmail && !isLeadEmailLoading && isEmailFetched && (
                                    <small className="text-danger">
                                        Email not found. Please update email in lead details.
                                    </small>
                                )}
                                {leadEmail &&
                                    leadEmail.trim() !== "" &&
                                    !isLeadEmailLoading && (
                                        <small className="text-success">
                                            <i className="fas fa-check me-1"></i>
                                            Email found and will be used for payment link
                                        </small>
                                    )}
                            </div>

                            <div className="alert alert-info">
                                <i className="fas fa-info-circle me-2"></i>A payment link will
                                be generated and sent to the patient. The patient can complete
                                the payment remotely.
                            </div>
                        </div>
                    ) : (
                        <form onSubmit={handleCollectPayment}>
                            {isServiceCaller ? (
                                <>
                                    <div className="form-group mb-3">
                                        <label htmlFor="feeSelection">Select Fee Type</label>
                                        <select
                                            id="feeSelection"
                                            className="form-control"
                                            value={selectedFeeOption}
                                            onChange={(e) => {
                                                const selected = e.target.value;
                                                setSelectedFeeOption(selected);
                                                setFeeValue(
                                                    selected === "Consulting Fees"
                                                        ? consultingFees
                                                        : selected === "Repeating Consulting Fees"
                                                            ? repeatingConsultingFees
                                                            : ""
                                                );
                                            }}
                                        >
                                            <option value="">-- Select Fee Type --</option>
                                            <option value="Consulting Fees">Consulting Fees</option>
                                            <option value="Repeating Consulting Fees">Repeating Consulting Fees</option>
                                        </select>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Amount</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="amount"
                                            value={feeValue ? `₹ ${feeValue}` : "Loading..."}
                                            readOnly
                                            disabled
                                            style={{ backgroundColor: "#f8f9fa", fontWeight: 500 }}
                                        />
                                    </div>
                                </>
                            ) : (
                                <div className="mb-3">
                                    <label className="form-label">Amount</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="amount"
                                        value={consultingFees ? `₹ ${consultingFees}` : "Loading..."}
                                        readOnly
                                        disabled
                                        style={{ backgroundColor: "#f8f9fa", fontWeight: 500 }}
                                    />
                                </div>
                            )}

                            <div className="mb-3">
                                <label className="form-label">
                                    Payment Mode <span className="text-danger">*</span>
                                </label>
                                <Select
                                    name="paymentType"
                                    options={[
                                        { value: "", label: "Select Payment Mode", isDisabled: true },
                                        { value: "Online", label: "Online" },
                                        { value: "Bankingcard", label: "Banking Card" },
                                        { value: "Upi", label: "UPI" },
                                        { value: "Offline", label: "Cash" },
                                    ]}
                                    value={
                                        paymentDetails.paymentType
                                            ? { value: paymentDetails.paymentType, label: paymentDetails.paymentType }
                                            : null
                                    }
                                    onChange={(selectedOption) =>
                                        handlePaymentInputChange({
                                            target: { name: "paymentType", value: selectedOption.value },
                                        })
                                    }
                                    placeholder="Select Payment Mode"
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            minHeight: "50px",
                                            height: "50px",
                                        }),
                                        singleValue: (provided) => ({
                                            ...provided,
                                            lineHeight: "50px",
                                        }),
                                        dropdownIndicator: (provided) => ({
                                            ...provided,
                                            padding: "4px",
                                        }),
                                        indicatorSeparator: () => ({
                                            display: "none",
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            zIndex: 9999, // to ensure it's above modal
                                        }),
                                    }}
                                    menuPlacement="auto"
                                />
                            </div>



                            {paymentDetails.paymentType === "Offline" && (
                                <>
                                    <div className="mb-3">
                                        <label className="form-label">Coupon Code (Optional)</label>
                                        <div className="input-group">
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="coupon"
                                                value={paymentDetails.coupon}
                                                onChange={handlePaymentInputChange}
                                                placeholder="Enter coupon code"
                                                ref={couponInputRef}
                                            />
                                            <button
                                                className="btn btn-outline-secondary"
                                                type="button"
                                                onClick={handleApplyCoupon}
                                            >
                                                Apply
                                            </button>
                                        </div>
                                    </div>

                                    {paymentDetails.finalAmount !== null && (
                                        <div className="mb-3">
                                            <strong>
                                                Final Amount: ₹{paymentDetails.finalAmount}
                                            </strong>
                                        </div>
                                    )}
                                </>
                            )}
                        </form>
                    )}
                </Modal.Body>

                <Modal.Footer>
                    {selectedAppointmentForPaymentLink ? (
                        <div className="d-flex gap-2">
                            <Button
                                variant="secondary"
                                onClick={() => {
                                    setShowPaymentModal(false);
                                    setSelectedAppointmentForPaymentLink(null);
                                    setLeadEmail(""); // Clear email when modal is closed
                                    setIsEmailFetched(false); // Reset email fetched state
                                    setPatientOrLeadName(""); // Clear patient/lead name when modal is closed
                                }}
                            >
                                Close
                            </Button>
                            {/* Check if email is required and available */}
                            {(() => {
                                const hasEmail = leadEmail && leadEmail.trim() !== "";
                                const isEmailRequired = !hasEmail; // Email is required for all appointments
                                const isEmailLoading = isLeadEmailLoading || !isEmailFetched; // Disable while loading or not fetched

                                const sendButton = (
                                    <SendPaymentLinkButton
                                        patientId={
                                            selectedAppointmentForPaymentLink.patient_id || patientId
                                        }
                                        appointmentId={
                                            selectedAppointmentForPaymentLink.appointment_id
                                        }
                                        leadId={selectedAppointmentForPaymentLink.lead_id || leadId}
                                        prescriptionId={null}
                                        queueId={null}
                                        patientName={
                                            patientOrLeadName ||
                                            selectedAppointmentForPaymentLink.patient_name ||
                                            "Patient"
                                        }
                                        amount={isServiceCaller && repeatingConsultingFees ? repeatingConsultingFees : consultingFees}
                                        paymentFor="Appointment"
                                        paymentType="appointment"
                                        disabled={isEmailRequired || isEmailLoading}
                                        email={leadEmail} // Pass email to the component
                                        onSuccess={() => {
                                            setShowPaymentModal(false);
                                            setSelectedAppointmentForPaymentLink(null);
                                            setLeadEmail(""); // Clear email when modal is closed
                                            setIsEmailFetched(false); // Reset email fetched state
                                            setPatientOrLeadName(""); // Clear patient/lead name when modal is closed
                                        }}
                                    />
                                );

                                if (isEmailRequired || isEmailLoading) {
                                    const tooltipText = isEmailLoading
                                        ? "Loading email details..."
                                        : "Email not found. Please update email in lead/patient details.";

                                    return (
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip id="email-tooltip">{tooltipText}</Tooltip>
                                            }
                                        >
                                            <span className="d-inline-block">{sendButton}</span>
                                        </OverlayTrigger>
                                    );
                                }

                                return sendButton;
                            })()}
                        </div>
                    ) : (
                        <Button
                            style={{ background: "#007680", border: "none" }}
                            onClick={handleCollectPayment}
                        >
                            Collect Payment
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>
        </div>
    );
};

PanchkarmaCommonAppointmentCalendar.propTypes = {
    module: PropTypes.string,
    leadId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    patientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    doctorId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    appointmentType: PropTypes.string,
    currentPatientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    currentLeadId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    allowBooking: PropTypes.bool,
    onBookingSuccess: PropTypes.func,
    onCancelSuccess: PropTypes.func,
    onRescheduleSuccess: PropTypes.func,
    onRescheduleError: PropTypes.func,
    onRescheduleStart: PropTypes.func,
    onRescheduleEnd: PropTypes.func,
    initialStartDate: PropTypes.instanceOf(Date),
    initialEndDate: PropTypes.instanceOf(Date),
    initialAppointmentId: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    currentAppointmentData: PropTypes.object,
    isNewBooking: PropTypes.bool,
};

export default PanchkarmaCommonAppointmentCalendar;
